import { AssetQuantity, Transaction } from 'api/types/transaction/transactionApiTypes'

// if a converted value already exists for the override's asset, replace the existing amount
// otherwise, append to the array
export const getOverriddenConvertedValues = (
  txn: Transaction,
  overrideMatch: { asset: string; value: number }
) => {
  const existingValueIndex = txn.value.convertedValues.findIndex(
    (convertedValue: AssetQuantity) => convertedValue.asset === overrideMatch.asset
  )

  if (existingValueIndex !== -1) {
    const convertedValues = [...txn.value.convertedValues]
    convertedValues[existingValueIndex].amount = overrideMatch.value

    return convertedValues
  }

  return [{ amount: overrideMatch.value, asset: overrideMatch.asset }, ...txn.value.convertedValues]
}
